import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const root = css`
  background: #cff8b0;
  border-radius: ${spacing(3)};
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  min-block-size: ${spacing(9)};
  padding-inline: ${spacing(2)};
  text-decoration: none;
  margin-block-start: ${spacing(1)};
`

export const withAdvert = css`
  border-radius: ${spacing(3)} ${spacing(3)} ${spacing(1)} ${spacing(3)};
`

export const withTrailImage = css`
  padding-inline-end: ${spacing(11)};
  margin-block-start: ${spacing(3)};
`

export const button = css`
  padding: ${spacing(0, 1)};
`

export const trailImage = css`
  position: absolute;
  inset-block-end: 0;
  inset-inline-end: 0;
`

export const advertBadge = css`
  position: absolute;
  inset-block-end: 0;
  inset-inline-end: 0;
  z-index: 1;
`
